<section class="curation-editor-wrapper" *ngIf="isDataLoaded">
  <gen-overlay-loader *ngIf="loading" class="curation-editor-overlay-loader"></gen-overlay-loader>
  <gen-curation-editor-header
    [curationItem]="curationItem"
    [curationStatus]="curationStatus"
    [revisionsData$]="revisionsData"
    [revisionName]="currentRevisionName"
    [readOnlyUserMode]="readOnlyUserMode"
    (revisionSelected)="revisionHistoryRowClick($event)"
    [revisionLastUpdatedDate]="revisionLastUpdatedDate"
    [lastManualOpinionName]="lastManualOpinionName"
  >
  </gen-curation-editor-header>
  <gen-curation-editor-actions
    [curationStatus]="curationStatus"
    [curationKey]="curationKey"
    [approvalUserMode]="approvalUserMode"
    [publishUserMode]="publishUserMode"
    [curatorUserMode]="curatorUserMode"
    [isAssignee]="isCurationItemAssignedToCurrentUser"
    [buttonsDisabled]="actionsDisabledMode"
    [curationItem]="curationItem"
    [oldRevisionMessage]="oldRevisionMessage"
    [readOnlyUserMode]="readOnlyUserMode"
    [multiStepReview]="multiStepReview"
    [revisedRelatedEntities]="revisedRelatedEntities"
    [revisiedEntitiesTableData]="revisiedEntitiesTableData"
    [newNotes]="newNotes"
    [reassignButtonDisabled]="isReassignButtonDisabled"
    [historyData]="revisionsData"
    (statusChanged)="changeStatus($event.status)"
    (statusChangedToRejected)="reject()"
    (goBackEvent)="goBack(true)"
    (notesPanelToggled)="toggleNotesPanel()"
    (toggleReassignCurationItem)="reassignCurationItem()"
    (toggleSubmitCurationItemForReview)="submitCurationItemForReview()"
    [sameOrganization]="sameOrganization"
    [showStopWorkflowButton]="showStopWorkflowButton"
    [showArchiveReason]="showArchiveReason"
    (toggleShowArchiveReason)="viewArchiveReason()"
  >
  </gen-curation-editor-actions>
  <gen-panel
    name="CURATION-NOTES-PANEL"
    class="{{notesPanelClass}}"
    (toggleDisplayStatusChanged)="toggleDisplayStatusChanged($event)">
  </gen-panel>
  <section class="scrollable">
    <section class="curation-editor-content" [ngClass]="curationStatus" *ngIf="isDataLoaded">
      <span class="titles">Treatment Plan Details</span>
      <gen-dynamic-form
        [listenToDataChange]="true"
        [formData]="formData"
        [formName]="this.editorFormsMap['details'].name"
        [formVertical]="true"
        [updateOnBlur]="false"
        [updatedFieldsContext]="updatedFieldsContext"
        [submitted]="submitted"
        (formChange)="updateForm($event.form, $event.updated)"
        [disabledFields]="disabledField"
        (validateChange)="validationEvent($event)"
        [disabled]="readOnlyMode"
        [additionalSearchValues]="revisedEntitiesRevisionsData"
        (linkClick)="downloadApprovalPDF($event)">
      </gen-dynamic-form>
    </section>
    <section class="item-section">
      <gen-overlay-loader *ngIf="loading" class="curation-editor-overlay-loader"></gen-overlay-loader>
      <gen-curation-editor-table-container
        [title]="getListTitle()"
        [readOnly]="readOnlyMode"
        [tableData]="getListData()"
        [itemTitle]="getItemTitle()"
        [formName]="getFormName()"
        [revisionTag]="revisionTag"
        [approvedMode]="approvedMode"
        [itemOverrides]="getItemOverrides()"
        [userCreatedTag]="userCreatedTagPrefix"
        [submitted]="submitted"
        [cloneAvailable]="getItemAllowDuplicate()"
        [applyClone]="true"
        (itemChanged)="itemUpdate($event)"
        (itemChangedAndUpdateRow)="itemUpdate($event)">
      </gen-curation-editor-table-container>
    </section>
    <section class="item-section">
      <gen-curation-editor-table-container
        [title]="'Citations'"
        [readOnly]="readOnlyMode"
        [tableData]="curationItem.curationData['content']['citations']"
        [itemTitle]="'Citations'"
        [formName]="citationsFormName"
        [revisionTag]="revisionTag"
        [approvedMode]="approvedMode"
        [itemOverrides]="itemOverrides"
        [userCreatedTagsSet]="userCreatedTagsSet"
        [submitted]="submitted"
        (itemChanged)="citationUpdate($event)">
      </gen-curation-editor-table-container>
    </section>
    <section class="item-section" *ngIf="!!this.editorFormsMap['ariaTemplates']">
      <gen-curation-editor-table-container
        [title]="'ARIA Template(s)'"
        [readOnly]="readOnlyMode"
        [tableData]="curationItem.curationData['content']['ariaTemplates']"
        [itemTitle]="'ARIA Template(s)'"
        [formName]="ariaTemplatesFormName"
        [revisionTag]="revisionTag"
        [approvedMode]="approvedMode"
        [itemOverrides]="itemOverrides"
        [submitted]="submitted"
        (itemChanged)="ariaTemplatesUpdate($event)">
      </gen-curation-editor-table-container>
    </section>
    <section class="item-section rationalization" style="margin-bottom: 20px;"
             *ngIf="!!this.editorFormsMap['rationalization']">
      <span class="titles">Revision Rationalization</span>
      <gen-dynamic-form
        [listenToDataChange]="true"
        [formData]="curationItem.curationData['content']"
        [formName]="this.editorFormsMap['rationalization'].name"
        [formVertical]="true"
        [updateOnBlur]="false"
        [updatedFieldsContext]="updatedFieldsContext"
        [submitted]=submitted
        (formChange)="updateForm($event.form, $event.updated)"
        [disabledFields]="disabledField"
        (validateChange)="validationEvent($event)"
        [disabled]="readOnlyMode"
        [saveFormControlsInStore]="true"
        [emitFormChangeEvenIfInvalid]="true"
        [additionalSearchValues]="revisedEntitiesRevisionsData">
      </gen-dynamic-form>
    </section>
  </section>
</section>

<gen-dynamic-modal-loader [observableName]="'TREATMENT_PLAN_NOTES_POPUP'"></gen-dynamic-modal-loader>
